import { render, staticRenderFns } from "./Paired.vue?vue&type=template&id=1ed3c3fb&scoped=true&"
import script from "./Paired.vue?vue&type=script&lang=js&"
export * from "./Paired.vue?vue&type=script&lang=js&"
import style0 from "./Paired.vue?vue&type=style&index=0&id=1ed3c3fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed3c3fb",
  null
  
)

export default component.exports